import { render, staticRenderFns } from "./KnowledgeBaseDetail.vue?vue&type=template&id=5dec00c6&scoped=true"
import script from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseDetail.vue?vue&type=style&index=0&id=5dec00c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec00c6",
  null
  
)

export default component.exports